import styled from "@emotion/styled";
import { Link } from "react-router-dom";
export const Container = styled.div`
  background: white;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 576px) {
    font-size: 10px;
  }
`;
export const ContainerMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const Logo = styled.img`
  width: 50%;
`;
export const Message = styled.div`
  font-family: Poppins Medium;
  font-size: 2em;
  color: #6d6d6d;
  text-align: center;
  @media (max-width: 576px) {
    width: 80%;
  }
`;
export const LinkMessage = styled(Link)`
  font-family: Poppins Medium;
  display: block;
  font-size: 1em;
  color: #6d6d6d;
  text-align: center;
  @media (max-width: 576px) {
    width: 80%;
  }
`;
